import { Pipe } from '@angular/core';
import { isString } from '../utils/utils';
var DecodeURIComponentPipe = (function () {
    function DecodeURIComponentPipe() {
    }
    DecodeURIComponentPipe.prototype.transform = function (input) {
        if (!isString(input)) {
            return input;
        }
        return decodeURIComponent(input);
    };
    return DecodeURIComponentPipe;
}());
export { DecodeURIComponentPipe };
DecodeURIComponentPipe.decorators = [
    { type: Pipe, args: [{
                name: 'decodeURIComponent'
            },] },
];
/** @nocollapse */
DecodeURIComponentPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=decode-uri-component.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/decode-uri-component.pipe.js
// module id = 274
// module chunks = 103